import { Button } from 'antd'
import { CheckCircleOutlined, DeleteOutlined, StopOutlined } from '@ant-design/icons'

type EditClientFooterProps = {
  currentEditStatusId: number
  statusActionLoading: boolean
  deleteLoading: boolean
  saveLoading: boolean
  onStatusClick: () => void
  onDeleteClick: () => void
  onCancel: () => void
  onSave: () => void
}

export function EditClientFooter({
  currentEditStatusId,
  statusActionLoading,
  deleteLoading,
  saveLoading,
  onStatusClick,
  onDeleteClick,
  onCancel,
  onSave,
}: EditClientFooterProps) {
  return (
    <div className="mt-8 flex flex-wrap items-center gap-2 border-t border-brand-100 pt-6">
      <Button
        type="primary"
        danger={currentEditStatusId === 1}
        icon={currentEditStatusId === 1 ? <StopOutlined /> : <CheckCircleOutlined />}
        loading={statusActionLoading}
        onClick={onStatusClick}
      >
        {currentEditStatusId === 2 ? 'Mark Active' : 'Mark Inactive'}
      </Button>
      <Button danger icon={<DeleteOutlined />} loading={deleteLoading} aria-label="Delete client" onClick={onDeleteClick}>
        Delete
      </Button>
      <Button onClick={onCancel}>Cancel</Button>
      <Button type="primary" aria-label="Save client" onClick={() => void onSave()} loading={saveLoading}>
        Save
      </Button>
    </div>
  )
}
